import { animate, state, style, transition, trigger } from '@angular/animations'
import { NgClass, NgTemplateOutlet } from '@angular/common'
import { Component, Input, ViewEncapsulation } from '@angular/core'
import { MarkdownDirective } from '../../directives'
import { Icon } from '../../lib/icon'
import { NotificationType } from '../../services/notification/notification-type'
import { assertUnreachable } from '../../util'
import { IconLegacyComponent } from '../icon-legacy'

const ANIMATION_DURATION = 100

/** @deprecated use {@link AlertComponent} instead */
@Component({
  selector: 'ftr-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  animations: [
    trigger('smoothEnter', [
      state('in', style({ height: 'auto' })),
      transition('void => *', [style({ height: '0' }), animate(ANIMATION_DURATION)]),
      transition('* => void', [animate(ANIMATION_DURATION, style({ height: 'auto' }))]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, IconLegacyComponent, MarkdownDirective, NgTemplateOutlet],
})
export class NotificationComponent {
  @Input() type: NotificationType
  /**
   * Remove the top and bottom margins.
   */
  @Input() compact = false
  /**
   * Render text with markdown syntax (default true), NOTE: this seems to prevent child components from rendering.
   */
  @Input() markdown = true
  /**
   * Display like a toast with no borders, a drop shadow etc.
   */
  @Input() toast = false

  getIcon(): Icon {
    switch (this.type) {
      case NotificationType.Error:
        return 'ErrorCircleSolid'
      case NotificationType.Info:
        return 'InfoCircleSolid'
      case NotificationType.Success:
        return 'CheckmarkCircle'
      case NotificationType.Warn:
        return 'Warning'
      default:
        assertUnreachable(this.type)
    }
  }
}
